import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { TrustedDeviceService } from '../services/utils/trusted-device.service';

export const deviceInfoInterceptor: HttpInterceptorFn = (req, next) => {
  const isLoginRequest = req.method === 'POST' && req.url.endsWith('/auth/login');

  if (!isLoginRequest) {
    return next(req);
  }

  const deviceService = inject(TrustedDeviceService);

  return from(deviceService.generateDeviceHash()).pipe(
    switchMap((hash) => {
      const clonedReq = req.clone({
        setHeaders: {
          'X-Device-Hash': hash,
        },
      });
      return next(clonedReq);
    }),
  );
};
